import React, { useState } from 'react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito conocimientos previos de supervivencia?',
    a: 'No. El Protocolo Blackout fue diseñado específicamente para personas normales que viven en apartamentos y ciudades. No se necesita experiencia militar ni de camping. Si podés leer y seguir instrucciones paso a paso, podés implementar este sistema hoy mismo.'
  }, {
    q: '¿Cómo recibo el material después de comprar?',
    a: 'Inmediatamente después de completar tu pago, recibirás un email con todos los accesos. El Ebook principal y los 5 bonos estarán disponibles para descargar en formato PDF de alta calidad. Acceso instantáneo, sin esperas.'
  }, {
    q: '¿Funciona si vivo en un apartamento pequeño?',
    a: 'Especialmente diseñado para apartamentos. La mayoría de los sistemas de supervivencia asumen que tenés una casa con jardín o un campo. Este protocolo fue creado pensando en el 80% de la población urbana que vive en espacios reducidos.'
  }, {
    q: '¿Cuánto tiempo lleva implementar el sistema?',
    a: 'El kit básico de emergencia se puede armar en un fin de semana con menos de $50. El sistema completo lleva entre 2 y 4 semanas de preparación gradual. Hay un plan de acción de 30 días incluido para que lo hagas sin estrés.'
  }, {
    q: '¿Y si compro y no me sirve?',
    a: 'Tenés 30 días de garantía total. Si por cualquier motivo no estás satisfecho, te devolvemos el 100% de tu inversión sin hacer preguntas. El riesgo es completamente nuestro.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-[#0a0a0a] py-12 px-5" data-id="element-72">
      <div className="max-w-[800px] mx-auto" data-id="element-73">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold text-center mb-8 leading-[1.2]" data-id="element-74">
          Preguntas <span className="text-brand-orange" data-id="element-75">frecuentes</span>
        </h2>

        <div className="max-w-[700px] mx-auto space-y-2" data-id="element-76">
          {faqs.map((faq, index) => <div key={index} className="bg-[#141414] border border-[#333] rounded-lg overflow-hidden transition-all duration-300" data-id="element-77">
              <button onClick={() => toggleFAQ(index)} className="w-full px-5 py-4 text-left font-semibold text-sm md:text-[15px] flex justify-between items-center focus:outline-none" data-id="element-78">
                <span className="pr-4" data-id="element-79">{faq.q}</span>
                <span className={`text-brand-orange text-2xl font-light transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`} data-id="element-80">
                  +
                </span>
              </button>
              <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-81">
                <p className="text-sm text-[#aaa] leading-[1.6]" data-id="element-82">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}